import axios from 'axios';
import ApiUrl from './config';
import { Gender } from './apiClient';

// Поиск и объединение дубликатов людей (только для админа). Эндпоинтов нет в сгенерированном apiClient.

export interface MergeApplication {
  participantId: number;
  tournamentId: number;
  tournamentName: string;
  weight: number;
  organization?: string;
  hasMatches: boolean;
}

export interface MergePerson {
  id: number;
  lastName: string;
  firstName: string;
  patronymic?: string;
  birthDate: string;
  city: string;
  gender?: Gender;
  email?: string;
  hasAccount: boolean;
  isChild: boolean;
  guardianId?: number;
  createdOn: string;
  roles: string[];
  applications: MergeApplication[];
}

export interface MergeCandidatePair {
  confidence: 'exact' | 'possible';
  a: MergePerson;
  b: MergePerson;
  suggestedPrimaryId: number;
}

export interface MergeConflict {
  tournamentId: number;
  tournamentName: string;
  primary: MergeApplication;
  secondary: MergeApplication;
}

export interface MergePreview {
  primary: MergePerson;
  secondary: MergePerson;
  conflicts: MergeConflict[];
  notes: string[];
  blockers: string[];
}

export interface MergeResult {
  primaryId: number;
  movedApplications: number;
  droppedApplications: number;
  movedChildren: number;
  message: string;
}

export async function getDuplicates(): Promise<MergeCandidatePair[]> {
  const response = await axios.get<MergeCandidatePair[]>(`${ApiUrl}/api/PersonMerge/Duplicates`);
  return response.data ?? [];
}

export async function getMergePreview(primaryId: number, secondaryId: number): Promise<MergePreview> {
  const response = await axios.get<MergePreview>(`${ApiUrl}/api/PersonMerge/Preview`, { params: { primaryId, secondaryId } });
  return response.data;
}

export async function mergePersons(
  primaryId: number,
  secondaryId: number,
  keepOnConflict?: 'primary' | 'secondary'
): Promise<MergeResult> {
  const response = await axios.post<MergeResult>(`${ApiUrl}/api/PersonMerge/Merge`, { primaryId, secondaryId, keepOnConflict });
  return response.data;
}

export const personFullName = (p: { lastName: string; firstName: string; patronymic?: string }) =>
  `${p.lastName} ${p.firstName}${p.patronymic ? ` ${p.patronymic}` : ''}`;

/** Календарная дата рождения (клиент шлёт полночь по местному времени, на сервере она хранится как UTC). */
export const formatBirthDate = (value: string) => new Date(value).toLocaleDateString('ru-RU');
